<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import { parseTags } from '../format';

  let {
    field: _field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  let draft = $state('');
  const tags = $derived(parseTags(value));

  function add() {
    const t = draft.trim();
    if (!t) return;
    if (tags.includes(t)) {
      draft = '';
      return;
    }
    onChange([...tags, t]);
    draft = '';
  }

  function remove(tag: string) {
    onChange(tags.filter((x) => x !== tag));
  }

  function onKey(e: KeyboardEvent) {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      add();
    } else if (e.key === 'Backspace' && draft === '' && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  }
</script>

<div
  class="flex flex-wrap items-center gap-1 rounded-md border bg-white px-2 py-1.5 text-sm {error
    ? 'border-red-400'
    : 'border-[var(--color-border-3)]'}"
>
  {#each tags as tag (tag)}
    <span class="inline-flex items-center gap-1 rounded-full bg-[var(--color-pu)] px-2 py-0.5 text-[11px] font-medium text-white">
      {tag}
      {#if !disabled}
        <button
          type="button"
          onclick={() => remove(tag)}
          class="text-white/80 hover:text-white"
          aria-label="видалити"
        >×</button>
      {/if}
    </span>
  {/each}
  <input
    type="text"
    bind:value={draft}
    onkeydown={onKey}
    onblur={add}
    {disabled}
    placeholder={tags.length === 0 ? 'Enter або кома щоб додати…' : ''}
    class="flex-1 min-w-[120px] border-0 bg-transparent px-1 py-0.5 text-sm outline-none"
  />
</div>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
